import { Card, Grid, makeStyles } from '@material-ui/core';
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { ModificacionAfiliados } from './ModificacionAfiliados';
import { Buscador } from '../Buscador';
import { desSeleccionarAfiliado } from '../../../actions/afiliado';

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
  center: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export const ModificacionesAfiHome = () => {

  const classes = useStyles();
  const { afiliado } = useSelector((state) => state.afiliacion);
  const dispatch = useDispatch()


  useEffect(() => {
    dispatch(desSeleccionarAfiliado());
  }, [])

  console.log(afiliado)
  return (

    <Grid container justify="center">
      <Grid item xs={12} md={6} className={classes.root}>
        <Buscador />
      </Grid>
      <Grid item xs={12} className={classes.center}>
        <Card>
        {afiliado?.id_afiliado > 0 && <ModificacionAfiliados afiliado={afiliado} />}
      </Card>
    </Grid>
    </Grid >

  )
}
